// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BookOpenText as RawBookOpenText } from "lucide-react";
export const BookOpenText = /* @__PURE__ */ createIcon(RawBookOpenText, "BookOpenText", 2);
